module.exports = __webpack_public_path__ + "img/mobile.9830ea6f.png";